import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import SiteVisit from "./SiteVisit";
import { documentUploadUrlPublic } from 'services/redux/fileUpload/action';
import {siteByCity, createSiteVisit } from 'services/redux/networkEngineer/action';
import {getSiteData} from "../../../services/redux/DistanceCalculator/action";

const mapStateToProps = (state) => ({
    documentUrlDataPublic: state.fileUploadReducer.documentUrlDataPublic,
    siteDetails: state.NetEnggReducer.siteDetails,
    savedVisitTask: state.NetEnggReducer.savedVisitTask,
    siteDetailsList: state.leadDataReducer.siteData,
});

const mapDispatchToProps = (dispatch) =>
    bindActionCreators(
        {
            documentUploadUrlPublic,
            siteByCity,
            createSiteVisit,
            getSiteData,
        },
        dispatch
    );


export default connect(mapStateToProps, mapDispatchToProps)(SiteVisit);